import React, { useId } from 'react';
import './courseKit.css';

export const TRUSTPILOT_URL = 'https://www.trustpilot.com/review/lumiwealth.com';

const Star = ({ fill, id }) => (
  <svg className="ck-star" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
    <defs>
      <linearGradient id={id}>
        <stop offset={`${fill * 100}%`} stopColor="currentColor" />
        <stop offset={`${fill * 100}%`} stopColor="transparent" stopOpacity="0" />
      </linearGradient>
    </defs>
    <path
      d="M10 1.6l2.6 5.3 5.8.8-4.2 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8L1.6 7.7l5.8-.8z"
      fill={`url(#${id})`}
      stroke="currentColor"
      strokeWidth="1"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Trustpilot rating with real star graphics and one coherent link target.
 * Deliberately shows no review count or year: both become stale quickly.
 */
const StarRating = ({
  rating = 4.6,
  showLink = true,
  compact = false,
  linkWholeRating = false,
}) => {
  const gradientPrefix = useId().replaceAll(':', '');
  const stars = [0, 1, 2, 3, 4].map((i) => Math.max(0, Math.min(1, rating - i)));
  const className =
    `ck-rating ${linkWholeRating ? 'ck-rating--link' : ''} ${compact ? 'is-compact' : ''}`
      .trim()
      .replace(/\s+/g, ' ');
  const content = (
    <>
      <span
        className="ck-stars"
        role={linkWholeRating ? undefined : 'img'}
        aria-label={linkWholeRating ? undefined : `${rating} out of 5 stars`}
        aria-hidden={linkWholeRating ? true : undefined}
      >
        {stars.map((fill, i) => (
          <Star
            key={i}
            fill={fill}
            id={`ck-star-${gradientPrefix}-${i}-${Math.round(fill * 100)}`}
          />
        ))}
      </span>
      <span className="ck-rating-value">{rating}</span>
      <span className="ck-rating-label">on Trustpilot</span>
    </>
  );

  if (showLink && linkWholeRating) {
    return (
      <a
        className={className}
        href={TRUSTPILOT_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${rating} out of 5 on Trustpilot`}
      >
        {content}
      </a>
    );
  }

  return (
    <div className={className}>
      <span className="ck-stars" role="img" aria-label={`${rating} out of 5 stars`}>
        {stars.map((fill, i) => (
          <Star
            key={i}
            fill={fill}
            id={`ck-star-${gradientPrefix}-${i}-${Math.round(fill * 100)}`}
          />
        ))}
      </span>
      <span className="ck-rating-value">{rating}</span>
      {showLink ? (
        <a
          className="ck-rating-link"
          href={TRUSTPILOT_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          on Trustpilot
        </a>
      ) : (
        <span className="ck-rating-label">on Trustpilot</span>
      )}
    </div>
  );
};

export default StarRating;
